import {Brick, registerBrick} from 'olympe';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import {fetchAndProcessIncoterms} from '../incotermsHelpers';

export default class SetIncotermsInPRJson extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} inputPRJson
     * @param {*} getIncoterms
     * @param {*} getAllIncoterms
     * @param {function()} forwardEvent
     * @param {function(string)} setPRJson
     * @param {function(*)} setErrorFlow
     */
    async update($, [inputPRJson, getIncoterms, getAllIncoterms], [forwardEvent, setPRJson, setErrorFlow]) {
        try {
            const parsedPR = new PurchaseRequest(inputPRJson);
            const vendorCode = parsedPR.vendorCode;

            let incotermResult;
            try {
                incotermResult = await fetchAndProcessIncoterms({
                    context: $,
                    getIncoterms: getIncoterms,
                    getAllIncoterms: getAllIncoterms,
                    vendorCode: vendorCode,
                    purchaseOrgValue: parsedPR.headerDetails.purchaseOrganization.value,
                    incoterms: parsedPR.headerDetails.incoterms,
                });
            } catch (error) {
                console.error('Error fetching incoterms:', error);
                incotermResult = {code: '', description: ''};
            }
            const {code, description} = incotermResult;

            parsedPR.headerDetails.incoterms = {
                data: {
                    label: description,
                    value: code,
                },
                manuallyModified: false,
            };

            setPRJson(JSON.stringify(parsedPR.getPurchaseRequest()));
            forwardEvent();
        } catch (error) {
            console.error('Error in SetIncotermsInPRJson - 0192f6902f5cfaaa41c7:', error);
            setErrorFlow(error);
        }
    }
}

registerBrick('0192f6902f5cfaaa41c7', SetIncotermsInPRJson);
